import { jwtDecode } from 'jwt-decode';

interface TokenType {
  user: {
    userId: string;
    type: 'admin' | 'investor';
  };
}

export const getAccountType = (token: string) => {
  const authToken = token;

  if (authToken && typeof authToken === 'string') {
    const decodedToken = jwtDecode(authToken) as TokenType;
    return decodedToken.user.type;
  }

  return null;
};
